"use client"; // Error boundaries must be Client Components

import { env } from "@/types/env";
import { Metadata } from "next";
import { useEffect } from "react";

export const metadata: Metadata = {
  title: "Ett fel uppstod | Vinprovning.se",
  description: "Ett oväntat fel har uppstått. Vi ber om ursäkt för besväret.",
};

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  const email = env.NEXT_PUBLIC_EMAIL;
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 text-center">
      <h1 className="text-3xl font-bold mb-4">Hoppsan! Något gick fel</h1>
      <p className="text-lg mb-6">
        Vi ber om ursäkt, men ett oväntat fel har uppstått. Vänligen försök igen
        eller kontakta oss på{" "}
        <a href={`mailto:${email}`} className="text-primary hover:underline">
          {email}
        </a>{" "}
        så tar vi detta med vår tekniker.
      </p>
      <button
        onClick={() => reset()}
        className="px-6 py-3 bg-primary text-white rounded-md hover:opacity-90 transition-opacity"
        aria-label="Försök igen"
      >
        Försök igen
      </button>
    </div>
  );
}
